import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'
import { OrdersTablesSkeleton } from '@root/widgets/trade/tables/orders-table/ui/orders-tables-skeleton'

import { tradingDrawerAtom } from '../../atoms'

import { OrdersViewTable } from './orders-view-table'

import type { Pair } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type AnalyticsViewProps = {
  pair: Pair.PairMinimal | undefined
} & ClassNameProps

type AnalyticsTab = 'orders' | 'all'

export const OrdersView: React.FC<AnalyticsViewProps> = ({
  className,
  pair,
}) => {
  const { t } = useTranslation()
  const [tab, setTab] = useState<AnalyticsTab>('orders')
  const [_tradingDrawer, setTradingDrawer] = useAtom(tradingDrawerAtom)

  return (
    <Root className={className}>
      <Header>
        <UnderlineTabs value={tab} onChange={setTab}>
          <UnderlineTabs.Tab value="orders">
            {t('trading.order.token-orders')}
          </UnderlineTabs.Tab>
          <UnderlineTabs.Tab
            value="all"
            onClick={() => setTradingDrawer('orders')}
          >
            {t('order.all-orders')}
          </UnderlineTabs.Tab>
        </UnderlineTabs>
      </Header>
      <Content>
        {pair ? <OrdersViewTable pair={pair} /> : <OrdersTablesSkeleton />}
      </Content>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Content = styled.div`
  display: grid;
`

const Header = styled.div`
  --tab-padding-inline: 8px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  background: var(--background-1);
  border-bottom: 1px solid var(--appearanceA-3);
  padding-inline: 12px;
`
